import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { IS_REF_MOBILE } from "../../../utils/refViewport";
import { getCasinoRulesHtml } from "../../../data/casinoRulesHtml";
import CardImg from "../../../components/CardImg";

const IMG = `${import.meta.env.BASE_URL}img/cards`;

/**
 * Reference vcasino top part (vlucky7 / vaaa):
 *   [.progress.mobile-timer (ft > 3)] + .casino-video >
 *     .casino-video-title + .video-box-container + .vcasino-cards (one card) + right icons (home, rules) + rules panel.
 */
export default function VCasinoVideo({ gameType, title, data, cardLabel }) {
  const [showRules, setShowRules] = useState(false);
  const [showRulesModal, setShowRulesModal] = useState(false);
  const rulesHtml = getCasinoRulesHtml(gameType) || "";
  const ft = Number(data?.ft) || 0;
  const lt = Number(data?.lt) || 0;
  const cards = data?.card != null && String(data.card).length ? String(data.card).split(",").map((c) => c.trim()) : [];

  return (
    <>
      {ft > 3 && (
        <div className="progress mobile-timer">
          <div
            className={`progress-bar ${lt <= 3 ? "bg-danger" : lt <= 6 ? "bg-warning" : "bg-success"}`}
            style={{ width: `${((100 * lt) / ft).toFixed(2)}%` }}
          />
        </div>
      )}{" "}
      <div className="casino-video">
        <div className="casino-video-title">
          <span className="casino-name">{title}</span>{" "}
          <div className="casino-video-rid">Round ID: {data?.mid}</div>
        </div>{" "}
        <div className="video-box-container">
          <div className="video-box" />
        </div>{" "}
        {cards.length > 0 && (
          <div className="vcasino-cards">
            <div className="text-center w-100">
              {cardLabel && (
                <>
                  <div className="w-100 playera mb-2">{cardLabel}</div>{" "}
                </>
              )}
              <span>
                <CardImg src={`${IMG}/${cards[0]}.png`} alt="" />
              </span>
            </div>
          </div>
        )}{" "}
        <div className="casino-video-right-icons">
          <div title="Home" className="casino-video-home-icon">
            <Link to="/admin/vcasino/list" style={{ color: "var(--text-highlight)" }}>
              <i className="fas fa-home" />
            </Link>
          </div>{" "}
          <div
            title="Rules"
            className="casino-video-rules-icon"
            onClick={() => {
              setShowRules(true);
              if (IS_REF_MOBILE) setShowRulesModal(true);
            }}
          >
            <i className="fas fa-info-circle" />
          </div>
        </div>{" "}
        <div>
          {showRules && (
            <div
              id="casino-vieo-rules"
              aria-modal="true"
              className="casino-vieo-rules show d-none-small show-rules"
              style={{ display: "block" }}
            >
              <div className="rules-header">
                <div>Rules</div> <i className="fas fa-times" onClick={() => setShowRules(false)} />
              </div>{" "}
              <div className="rules-body" dangerouslySetInnerHTML={{ __html: rulesHtml }} />
            </div>
          )}
          <Modal
            show={showRulesModal}
            onHide={() => setShowRulesModal(false)}
            className="casino-rules teenpatti2-rule-modal"
            dialogClassName="modal-md"
            id="rules-modal"
          >
            <header className="modal-header">
              <h5 className="modal-title">Rules</h5>{" "}
              <button type="button" aria-label="Close" className="close" onClick={() => setShowRulesModal(false)}>
                ×
              </button>
            </header>
            <Modal.Body>
              <div className="casino-vieo-rules show-rules show">
                <div className="rules-body" dangerouslySetInnerHTML={{ __html: rulesHtml }} />
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </>
  );
}
